<template>
  <div>
    <div
      class="tree-list-item-box"
      v-for="(item, index) in list"
      :key="
        item.type === 1 || item.type === 3
          ? 'dept_' + item.id
          : `${item.departmentId}_${item.id}`
      "
    >
      <span class="tree-list-item-span-box">
        <span
          class="tree-list-item-span-icon-box none-cursor"
          v-if="item.loading"
        >
          <i class="el-icon-loading"></i>
        </span>
        <span
          class="tree-list-item-span-icon-box"
          @click.stop="iconClick(item, index)"
          v-else-if="isLazyLoading ? item.expanded : false"
        >
          <i
            class="el-icon-arrow-right"
            v-if="actChildIds.indexOf(item[value]) === -1"
          ></i>
          <i class="el-icon-arrow-down" v-else></i>
          <!-- <i class="el-icon-arrow-down"></i> -->
        </span>
        <span class="tree-list-item-span-icon-box none-cursor" v-else></span>
        <span
          class="tree-list-item-span-name"
          :class="
            disabledKey && item.type === 2
              ? !item[disabledKey]
                ? 'disabled-name'
                : disableId(item)
                ? 'disabled-name'
                : ''
              : disableId(item)
              ? 'disabled-name'
              : ''
          "
          @click="itemClick(item, index)"
          v-html="formatName(item)"
        ></span>
        <span
          class="tree-list-item-span-icon-active-box"
          :class="
            disabledKey && item.type === 2
              ? !item[disabledKey]
                ? 'disabled-name'
                : disableId(item)
                ? 'disabled-name'
                : ''
              : disableId(item)
              ? 'disabled-name'
              : ''
          "
        >
          <i
            class="el-icon-check"
            v-if="
              item.type === 1 || item.type === 3
                ? deptIds.indexOf(item[value]) !== -1
                : isUserSelected(item)
            "
          ></i>
        </span>
      </span>
      <div
        v-if="item.children && item.children.length > 0"
        class="tree-list-item-child-box"
        :style="{
          display: actChildIds.indexOf(item[value]) === -1 ? 'none' : 'flex'
        }"
      >
        <tree-box
          v-bind="$props"
          :list="item.children"
          @itemClick="itemClick"
          @iconClick="iconClick"
        />
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'tree-box',
    props: {
      // 数据源
      list: {
        type: Array,
        default: () => []
      },
      // 展开的部门ids
      actChildIds: {
        type: Array,
        default: () => []
      },
      // 选中的人ids
      userIds: {
        type: Array,
        default: () => []
      },
      // 一人多岗下选人，是否将所有岗位下的人都选中，目前只有加签需要true
      isSelectMutiDeptInOneUser: {
        type: Boolean,
        default: false
      },
      // 已选中的完整对象列表，用于一人多岗判断
      activeList: {
        type: Array,
        default: () => []
      },
      // 选中部门ids
      deptIds: {
        type: Array,
        default: () => []
      },
      // 展示文案key
      label: {
        type: String,
        default: 'label'
      },
      // 保存选中项key
      value: {
        type: String,
        default: 'id'
      },
      // 禁止选中项key；其中true-可以选中，false-不可以选中
      disabledKey: {
        type: String,
        default: ''
      },
      // 是否开启懒加载
      isLazyLoading: {
        type: Boolean,
        default: false
      },
      // 禁用id列表
      disableList: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {};
    },
    methods: {
      formatName(item) {
        let labelStr = '';
        labelStr = item.deptName
          ? `${item.labelHtml}(${item.deptName})`
          : item.labelHtml;

        if (item.deptCode && item.type == 1) {
          labelStr += `(${item.deptCode})`;
        }
        return labelStr;
      },
      /**
       * 判断用户是否被选中
       * @param {Object} item - 用户对象
       * @returns {Boolean} 是否选中
       */
      isUserSelected(item) {
        // 如果不是用户类型，直接返回false
        if (item.type !== 2) {
          return false;
        }
        
        // 基础判断：用户ID是否在选中列表中
        const isUserIdSelected = this.userIds.indexOf(item[this.value]) !== -1;
        
        // 如果不需要考虑一人多岗，直接返回基础判断结果
        if (!this.isSelectMutiDeptInOneUser) {
          return isUserIdSelected;
        }
        
        // 一人多岗模式：需要检查用户在当前岗位下是否被选中
        // 同一个用户可能在多个岗位（部门）下，需要精确匹配用户ID+部门ID
        if (this.activeList && this.activeList.length > 0) {
          return this.activeList.some(selectedUser => {
            // 匹配用户ID和部门ID（岗位），确保同一用户在不同岗位下的选择状态正确
            return selectedUser[this.value] === item[this.value] && 
                   selectedUser.departmentId === item.departmentId;
          });
        }
        
        // 如果没有activeList数据，降级为基础判断
        return isUserIdSelected;
      },
      iconClick(val, index) {
        this.$emit('iconClick', val, index);
      },
      itemClick(val, index) {
        if (this.disabledKey && val.type === 2) {
          if (!val[this.disabledKey]) return;
        }
        this.$emit('itemClick', val, index);
      },
      disableId(val) {
        if (this.disableList?.length) {
          return this.disableList.some((item) => {
            if (
              item.type === val.type &&
              item[this.value] === val[this.value]
            ) {
              return true;
            }
            return false;
          });
        }
        return false;
      }
    }
  };
</script>

<style lang="scss" scoped>
  .tree-list-item-box {
    display: flex;
    flex-direction: column;
    .tree-list-item-span-box {
      width: 100%;
      display: flex;
      padding: 10px 0;
      color: #333333;
      font-size: 14px;

      .tree-list-item-span-icon-box {
        display: flex;
        align-items: center;
        width: 14px;
        height: 14px;
        cursor: pointer;
        margin-right: 5px;
        margin-top: 2px;
        flex-shrink: 0;
      }
      .tree-list-item-span-icon-active-box {
        display: flex;
        margin-left: 5px;
        margin-top: 2px;
      }
      .tree-list-item-span-name {
        flex: 1;
        cursor: pointer;
        display: flex;
        white-space: nowrap;
      }
      .none-cursor {
        cursor: default;
      }
      .disabled-name {
        color: #c0c4cc;
        cursor: not-allowed;
      }
      .disabled-icon {
        color: #c0c4cc;
      }
    }
    .tree-list-item-child-box {
      display: flex;
      flex-direction: column;
      margin-left: 10px;
      span {
        display: flex;
      }
    }
  }
</style>
